<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>Teklif Bilgileri</span>
        </template>
        <validation-observer ref="simpleRules">
          <offer-form
            :submit-form="submitForm"
            :submit-status="submitStatus"
            :remove-item="removeItem"
            :add-items="getProductList"
          />
        </validation-observer>
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>Müşteri Bilgileri</span>
        </template>
        <customer-info />
        <customer-invoice />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="ClockIcon" />
          <span>Müşteri Geçmişi</span>
        </template>
        <customer-history :customer-id="dataItem.id_customers" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import OfferForm from '@/views/Admin/Offers/OfferForm.vue'
import CustomerInfo from '@/views/Admin/Customers/View/CustomerInfo.vue'
import CustomerInvoice from '@/views/Admin/Customers/View/CustomerInvoice.vue'
import CustomerHistory from '@/views/Admin/Customers/View/CustomerHistory.vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Revised',
  components: {
    BTabs,
    BTab,
    OfferForm,
    CustomerInfo,
    CustomerInvoice,
    CustomerHistory,
    ValidationObserver,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['offers/dataItem']
    },
    dataList() {
      return this.$store.getters['offerLines/productList']
    },
    saveData() {
      return this.$store.getters['offers/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/app/offers/view/${val.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  beforeCreate() {
    this.$store.commit('offers/RESET_DATA_ITEM')
    this.$store.commit('offerLines/RESET_PRODUCT_DATA')
  },
  created() {
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      this.$store.dispatch('offers/getDataItem', { id: this.$route.params.id_offers, isUpdate: true, isRevised: true })
        .then(response => {
          if (response.id_customers) {
            this.getCustomer(response.id_customers)
            this.getDataList(response.id_projects)
          }
        })
    },
    getDataList(projects) {
      this.$store.dispatch('offerLines/getProductList', {
        id_projects: projects,
        id_offers: this.$route.params.id_offers,
      })
    },
    getCustomer(id) {
      this.$store.dispatch('customers/getDataItem', id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // this.submitStatus = true
          let processError = false
          this.dataItem.id_offers = this.dataItem.id
          this.dataItem.id = null
          this.dataItem.id_offer_statuses = 4 // revizeden dolayı
          this.dataItem.offer_lines = []
          for (let i = 0; i < this.dataList.length; i += 1) {
            for (let l = 0; l < this.dataList[i].productList.length; l += 1) {
              if (!this.dataItem.id_currencies || !this.dataList[i].productList[l].id_units) {
                this.showToast({
                  variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: 'Lütfen "Birim" ve "Para Birimi" alanlarını doldurduğunuzdan emin olun.',
                })
                processError = true
                break
              } else {
                delete this.dataList[i].productList[l].id
              }
              this.dataItem.offer_lines.push(this.dataList[i].productList[l])
            }
          }
          if (!processError) {
            this.$store.dispatch('offers/saveData', this.dataItem)
          }
        }
      })
    },
    getProductList() {
      this.$store.dispatch('offerLines/getProductList', {
        id_projects: this.dataItem.id_projects,
        id_offers: this.dataItem.id,
      })
    },
    removeItem(itemId, productType, index) {
      if (this.dataList.length > 0) {
        this.dataList[productType].productList.splice(index, 1)
      }
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
